import { render, staticRenderFns } from "./ZoneAnalysisPage.vue?vue&type=template&id=2897f3a4&scoped=true"
import script from "./ZoneAnalysisPage.vue?vue&type=script&lang=js"
export * from "./ZoneAnalysisPage.vue?vue&type=script&lang=js"
import style0 from "./ZoneAnalysisPage.vue?vue&type=style&index=0&id=2897f3a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2897f3a4",
  null
  
)

export default component.exports